import { v4 as uuidv4 } from "uuid";
import MaklerDatenService from "@/businesslogic/services/MaklerDatenService";
import Logger from "js-logger";
import dateUtils from "@/businesslogic/utils/dateUtils";
import { Anfrage, Status } from "@/model/Anfrage";
import cookieUtils from "@/businesslogic/utils/cookieUtils";

export default function formStoreInitializer(): any {
  const { getIsoDateNow, pruefeNach12Uhr, pruefe2902, getIsoDateNowPlus } = dateUtils();
  const { getCookie } = cookieUtils();

  const moeglichesPolicenStartdatum = () => {
    if (pruefeNach12Uhr() || pruefe2902()) {
      return getIsoDateNowPlus(1);
    } else {
      return getIsoDateNow();
    }
  };

  const storeInitialisiereStandardAllgemein = (state: Anfrage, isMakler: boolean, isMaklerLink: boolean) => {
    state.status = Status.NEU;
    state.isMakler = isMakler;
    state.isMaklerLink = isMaklerLink;
    state.tarifinformationen.zahlungsweise = 1;
    state.tarifinformationen.vorschaedenAnzahl = -1;
    state.tarifinformationen.versicherungsbeginn = moeglichesPolicenStartdatum();
    state.ferienhaus.vgv.tarifinformationen.versicherungsbeginn = state.tarifinformationen.versicherungsbeginn;
    state.ferienhaus.vhv.tarifinformationen.versicherungsbeginn = state.tarifinformationen.versicherungsbeginn;
    state.ferienhaus.hug.tarifinformationen.versicherungsbeginn = state.tarifinformationen.versicherungsbeginn;
    state.tarifinformationen.abschlagZuschlag = "002";
    state.korrespondenz.beilagen = isMakler ? "VORSCHLAG_UND_PRODUKTINFORMATIONEN" : "VOLLSTAENDIG";
    state.tarifinformationen.ablauf = "einJahr";
    state.zahlungsdaten.zahlungsart = "debit";
    state.affiliate = getCookie("s_id");
    state.personendaten.versicherungsnehmer.standardKommunikationsart = "EMAIL";
  };

  const storeInitialisiereStandardPhv = (state: Anfrage) => {
    state.verkaufsprodukt = "PHV";
    state.tarifinformationen.produktId = "K323000G0000";
    if (state.isMakler) {
      state.tarifinformationen.produktLinie = "003";
      state.tarifinformationen.versicherungssumme = 500;
    } else {
      state.tarifinformationen.produktLinie = "002";
      state.tarifinformationen.versicherungssumme = 100;
    }
  };

  const storeInitialisiereStandardPhv2025 = (state: Anfrage) => {
    state.verkaufsprodukt = "PHV2025";
    state.tarifinformationen.produktId = "P4G3000G0000";
    if (state.isMakler) {
      state.tarifinformationen.produktLinie = "003";
      state.tarifinformationen.versicherungssumme = 500;
    } else {
      state.tarifinformationen.produktLinie = "002";
      state.tarifinformationen.versicherungssumme = 100;
    }
  };

  const storeInitialisiereStandardVgv = (state: Anfrage) => {
    state.verkaufsprodukt = "VGV";
    state.tarifinformationen.produktId = "HW63000G0000";
    state.tarifinformationen.tarifVariante = "904";
    state.tarifinformationen.produktLinie = "003";
    state.tarifinformationen.selbstbeteiligung = state.isMakler ? 0 : 250;
    state.tarifinformationen.sfr = 1;
    state.gebaeudedaten.gebaeudetyp = state.isMakler ? "1" : "";
    state.gebaeudedaten.gebaeudenutzung = "0001";
    state.gebaeudedaten.dachbelag = "0";
    state.gebaeudedaten.bauart = "0001";
    state.gebaeudedaten.dachvariante = "3";
    state.gebaeudedaten.anzahlVollgeschosse = 1;
    state.gebaeudedaten.anzahlWohnungen = -1;
    state.gebaeudedaten.nebengebaeudeVorhanden = false;
    state.gebaeudedaten.kellerVorhanden = false;
    state.gebaeudedaten.parkplaetzeVorhanden = false;
    state.gebaeudedaten.rueckstausicherungVorhanden = true;
    state.gebaeudedaten.photovoltaikVorhanden = false;
    state.gebaeudedaten.schwimmbadVorhanden = false;
    state.gebaeudedaten.vermietet = false;
    state.gebaeudedaten.gewerbeVorhanden = false;
    state.gebaeudedaten.fertighaus = false;
    state.risikoAnschrift.sollPruefen = true;
  };

  const storeInitialisiereStandardVhv2024 = (state: Anfrage) => {
    state.verkaufsprodukt = "VHV2024";
    state.tarifinformationen.produktId = "7CF3000G0000";
    state.tarifinformationen.produktLinie = state.isMakler ? "003" : "002";
    state.tarifinformationen.versicherungssumme = null;
    state.tarifinformationen.fahrradschutz = state.isMakler;
    state.tarifinformationen.fahrradschutzBetrag = 1000;
    state.tarifinformationen.sfr = 1;
    state.gebaeudedaten.dachbelag = "0";
    state.gebaeudedaten.bauart = "0001";
  };

  const storeInitialisiereStandardBl = (state: Anfrage) => {
    state.verkaufsprodukt = "BL";
    state.tarifinformationen.produktId = "RJU0000G0000";
    state.tarifinformationen.produktLinie = "001";
    state.gebaeudedaten.gebaeudetyp = "8";
    state.gebaeudedaten.artDesBauvorhabens = "01";
    state.gebaeudedaten.alleineigentuemer = true;
    state.gebaeudedaten.nachbargebaeudeImEigentum = null;
    state.gebaeudedaten.eigenbauleistungen.statik = false;
    state.bauleitungDurchDritte = true;
  };

  const storeInitialisiereStandardBh = (state: Anfrage) => {
    state.verkaufsprodukt = "BH";
    state.tarifinformationen.produktId = "0LI0000G0000";
    state.tarifinformationen.produktLinie = "001";
    state.gebaeudedaten.gebaeudetyp = "8";
    state.gebaeudedaten.artDesBauvorhabens = "01";
    state.gebaeudedaten.eigenbauleistungen.statik = state.isMakler ? false : null;
    state.gebaeudedaten.alleineigentuemer = true;
    state.tarifinformationen.deckungssumme = 10000000;
    state.gebaeudedaten.nachbargebaeudeImEigentum = null;
    state.gebaeudedaten.eigenbauleistungen.statik = false;
    state.bauleitungDurchDritte = true;
  };

  const storeInitialisiereStandardHg = (state: Anfrage) => {
    state.verkaufsprodukt = "HG";
    state.tarifinformationen.produktId = "6S23000G0000";
    state.tarifinformationen.produktLinie = "003";
    state.gebaeudedaten.unbebautesGruendstueck = false;
    state.gebaeudedaten.alleineigentuemer = true;
    state.gebaeudedaten.gebaeudetyp = "0001";
    state.gebaeudedaten.gewerbeVorhanden = state.isMakler ? null : false;
    state.gebaeudedaten.gebaeudenutzung = "0000";
    state.tarifinformationen.deckungssumme = state.isMakler ? 500 : 100;
  };

  const storeInitialisiereStandardFh2024 = (state: Anfrage) => {
    state.verkaufsprodukt = "FH2024";
    state.abTest = "";
    state.tarifinformationen.produktId = "";
    state.tarifinformationen.tarifVariante = "";
    state.tarifinformationen.produktLinie = "";
    state.tarifinformationen.selbstbeteiligung = 250;
    state.tarifinformationen.sfr = 1;
    state.preise.produktLinienIndex = 0;
    state.gebaeudedaten.dachbelag = "0";
    state.gebaeudedaten.bauart = "0001";
    state.gebaeudedaten.anzahlWohnungen = -1;
    state.gebaeudedaten.dachvariante = "3";
    state.gebaeudedaten.anzahlVollgeschosse = 1;
    state.gebaeudedaten.unbebautesGruendstueck = false;
    state.gebaeudedaten.fertighaus = false;
    state.gebaeudedaten.kellerVorhanden = false;
    state.gebaeudedaten.parkplaetzeVorhanden = false;
    state.gebaeudedaten.rueckstausicherungVorhanden = true;
    state.gebaeudedaten.photovoltaikVorhanden = false;
    state.ferienhaus.versicherungsumfang = "0001";
    state.ferienhaus.vorschaedenVorhanden = -1;
    state.ferienhaus.vgv.tarifinformationen.vorschaedenAnzahl = -1;
    state.ferienhaus.vhv.tarifinformationen.vorschaedenAnzahl = -1;
    state.ferienhaus.hug.tarifinformationen.vorschaedenAnzahl = 0;
    state.ferienhaus.vgv.tageUnbewohnt = -1;
    state.ferienhaus.vhv.tageUnbewohnt = -1;
    state.ferienhaus.vgv.tarifinformationen.selbstbeteiligung = state.tarifinformationen.selbstbeteiligung;
    state.ferienhaus.vhv.tarifinformationen.selbstbeteiligung = state.tarifinformationen.selbstbeteiligung;
    state.ferienhaus.vgv.tarifinformationen.sfr = state.tarifinformationen.sfr;
    state.ferienhaus.vhv.tarifinformationen.sfr = state.tarifinformationen.sfr;
    state.ferienhaus.vgv.tarifinformationen.produktId = "HW63000G0000";
    state.ferienhaus.vhv.tarifinformationen.produktId = "7CF3000G0000";
    state.ferienhaus.hug.tarifinformationen.produktId = "6S23000G0000";
    state.ferienhaus.hug.tarifinformationen.deckungssumme = 100;
    state.ferienhaus.hug.tarifinformationen.zahlungsweise = state.tarifinformationen.zahlungsweise;
    state.ferienhaus.vgv.tarifinformationen.zahlungsweise = state.tarifinformationen.zahlungsweise;
    state.ferienhaus.vhv.tarifinformationen.zahlungsweise = state.tarifinformationen.zahlungsweise;
    state.ferienhaus.vgv.tarifinformationen.produktLinie = "005";
    state.ferienhaus.vhv.tarifinformationen.produktLinie = "005";
    state.ferienhaus.hug.tarifinformationen.produktLinie = "002";
  };

  const storeInitialisiereStandard = (
    state: Anfrage,
    produkt: string,
    isMakler: boolean,
    isMaklerLink: boolean,
    vorbelegungsId: string,
  ) => {
    storeInitialisiereStandardAllgemein(state, isMakler, isMaklerLink);
    switch (produkt.toLowerCase()) {
      case "phv":
        storeInitialisiereStandardPhv(state);
        break;
      case "phv2025":
        storeInitialisiereStandardPhv2025(state);
        break;
      case "vgv":
        storeInitialisiereStandardVgv(state);
        break;
      case "vhv2024":
        storeInitialisiereStandardVhv2024(state);
        break;
      case "bl":
        storeInitialisiereStandardBl(state);
        break;
      case "bh":
        storeInitialisiereStandardBh(state);
        break;
      case "hg":
        storeInitialisiereStandardHg(state);
        break;
      case "fh2024":
        storeInitialisiereStandardFh2024(state);
        break;
      default:
        Logger.debug(
          "storeInitialisiereStandard(): Keine Initialisierung, da unbekanntes Produkt.",
          state,
          produkt,
          isMakler,
          isMaklerLink,
        );
    }

    setzeOutbound(state);

    if (!vorbelegungsId) {
      ladeVermittlerdaten(state);
      ladeAbsenderdaten(state);
    }
    if (state.sessionId === undefined) {
      state.sessionId = uuidv4();
      Logger.debug("sessionId", state.sessionId);
    }
  };

  const ladeVermittlerdaten = (state: Anfrage) => {
    if (state.isMakler && !state.isMaklerLink) {
      MaklerDatenService.ladeVermittlerdaten(state.tarifinformationen.produktId, state.vermittlerNummer).then((res) => {
        setVermittler(res, state);
      });
    } else if (state.isMakler && state.isMaklerLink) {
      MaklerDatenService.ladeVermittlerdatenMaklerLink(state.tarifinformationen.produktId, state.vermittlerNummer).then(
        (res) => {
          setVermittler(res, state);
        },
      );
    }
  };

  function setVermittler(res: any, state: Anfrage) {
    if (res.status == 200) {
      state.personendaten.vermittler = res.data;
    }
  }

  function setzeOutbound(state: Anfrage) {
    if (!state.isMakler && !state.isMaklerLink) {
      state.outbound.downloadAktiv = process.env.VUE_APP_DOWNLOAD_OUTBOUND_AKTIV.split(", ").includes(
        state.verkaufsprodukt.toLowerCase(),
      );
      state.outbound.emailAktiv = process.env.VUE_APP_EMAIL_OUTBOUND_AKTIV.split(", ").includes(
        state.verkaufsprodukt.toLowerCase(),
      );
    }
  }

  const ladeAbsenderdaten = (state: Anfrage) => {
    if (state.isMakler && !state.isMaklerLink) {
      MaklerDatenService.ladeAbsenderdaten(state.vermittlerNummer)
        .then((res) => {
          if (res.status == 200) {
            state.korrespondenz.absenderinformationen = res.data;
          }
        })
        .catch((reason) => {
          console.debug("Es wurden keine Absenderdaten geladen.", reason);
        });
    }
  };

  return {
    storeInitialisiereStandard,
    ladeVermittlerdaten,
    ladeAbsenderdaten,
    moeglichesPolicenStartdatum,
  };
}
